export default "/_next/static/media/jordan-why-not-zer04-pf-basketball-shoe-P3c3Rp.6d619bf084f503866f16c8e09bc0b570.jpeg";